import { styled } from '@vebox/etui-system';
import { createElement } from 'react';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, Span } from '@vebox/etui-system-elements';
import { S as SvgDiv, a as Svg } from '../Svg-0180d7b5.js';
import '@vebox/etui-icons';
import './icons.js';
import { getIcon } from './helper.js';

const _excluded = ["size", "rotate"];
const SymbolDiv = styled(Div).attrs(_ref => {
  let {
      size,
      rotate
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: `${size}px`,
    height: `${size}px`,
    position: 'relative',
    transform: `rotate(${rotate}deg)`
  }, rest);
})``;

const SymbolSpan = styled(Span).attrs(({
  weight,
  size,
  color,
  style
}) => ({
  fontSize: `${size}px`,
  color: color || 'unset',
  fontVariationSettings: `'FILL' 0, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${size}`,
  style
}))`
  font-family: 'etui-symbols-${({
  weight
}) => weight}';
  font-weight: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizeLegibility;
  font-feature-settings: 'liga';
  user-select: none;
`;

function Icon({
  title,
  glyph,
  role,
  rotate,
  viewBox,
  symbol,
  weight = '300',
  size = symbol ? 20 : 24,
  color,
  styles = {},
  onRender,
  isIconLabel = false
}) {
  if (onRender) {
    return onRender();
  }
  if (glyph === undefined && !symbol) {
    return null;
  }
  if (symbol) {
    var _styles$symbol, _styles$symbol2;
    return /*#__PURE__*/createElement(SymbolDiv, {
      testId: symbol,
      size: size,
      rotate: rotate,
      style: (_styles$symbol = styles.symbol) === null || _styles$symbol === void 0 ? void 0 : _styles$symbol.root
    }, /*#__PURE__*/createElement(SymbolSpan, {
      weight: weight,
      size: size,
      color: color,
      style: (_styles$symbol2 = styles.symbol) === null || _styles$symbol2 === void 0 ? void 0 : _styles$symbol2.span
    }, symbol));
  }
  return /*#__PURE__*/createElement(SvgDiv, _extends({
    testId: "icon",
    rotate: rotate,
    size: size,
    role: role,
    color: color
  }, styles.root), /*#__PURE__*/createElement(Svg, _extends({
    style: {
      marginBottom: isIconLabel ? '10px' : ''
    },
    viewBox: viewBox || '0 0 84 84',
    xmlSpace: "preserve",
    id: title || glyph,
    "aria-labelledby": title ? 'title' : undefined
  }, styles.svg), title ? /*#__PURE__*/createElement("title", null, glyph) : null, getIcon(glyph)));
}

export default Icon;
